import { render, staticRenderFns } from "./AddToHomeScreenPrompt.vue?vue&type=template&id=1c866c5c&scoped=true"
import script from "./AddToHomeScreenPrompt.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreenPrompt.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreenPrompt.vue?vue&type=style&index=0&id=1c866c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c866c5c",
  null
  
)

export default component.exports